import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '#environments';
import { Area, AreaCreateUpdate } from '#models';

@Injectable({
  providedIn: 'root',
})
export class AreaService {
  private _httpClient = inject(HttpClient);

  getByBusinessUnit(businessUnitId: number): Observable<Area[]> {
    return this._httpClient.get<Area[]>(`${environment.apiUrl}/areas?businessUnitId=${businessUnitId}`);
  }

  create(payload: AreaCreateUpdate): Observable<Area> {
    return this._httpClient.post<Area>(`${environment.apiUrl}/areas`, payload);
  }

  update(id: number, payload: AreaCreateUpdate): Observable<Area> {
    return this._httpClient.put<Area>(`${environment.apiUrl}/areas/${id}`, payload);
  }

  delete(id: number): Observable<void> {
    return this._httpClient.delete<void>(`${environment.apiUrl}/areas/${id}`);
  }
}
